import { PublicPageTemplate } from "./PublicPageTemplate";

const DiagnosticPage = () => (
  <PublicPageTemplate
    badge="Diagnostic IA"
    title="Diagnostic gratuit de votre"
    highlight="entreprise"
    description="En 30 minutes, Grafton IA analyse vos pratiques et identifie vos leviers de croissance. 100% gratuit, sans engagement."
  />
);
export default DiagnosticPage;
